module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/2-5mill-active-fe1c2277a8522e6a8ed04d441459ce92.png";